module.exports = __webpack_public_path__ + "static/square-face-7391b96620707a60e37fa47dea7809db.png";